import productsStep from '../steps/products';
import buildingTypeStep from '../steps/buildingType';
import topicStep from '../steps/topic';

const steps = [buildingTypeStep, topicStep, productsStep];

export default steps;
